import React, { useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { createWalletPage } from '@egreact/shared';
import { getAPIUrl } from '../../script/util';
import Navbar from '../../components/Navbar/Navbar';
import StoreToken from '../../components/StoreToken';
import { useStateFields } from '../../store/hooks';
import useReferralLive, {
  useReferralProgramme,
} from '../../script/useReferralLive';
import ReferralRewardCard from '../Referral/ReferralRewardCard';
import './Wallet.css';

// A component rather than inline in renderBetween, which the wallet page
// only calls once the balance has loaded, so a hook cannot live there.
const ReferBlock = () => {
  const isReferralLive = useReferralLive();
  if (!isReferralLive) return null;
  const user = JSON.parse(localStorage.getItem('auth_dict') || '{}');
  const referralUrl = `/referral?utm_source=wallet&utm_campaign=referral&customer_id=${user?.eventGraphiaId}`;
  return (
    <Link to={referralUrl} className="wallet-refer-block">
      <div className="wallet-refer-left">
        <span className="wallet-refer-icon">🎁</span>
        <div className="wallet-refer-text">
          <p className="wallet-refer-title">Refer &amp; Earn</p>
          <p className="wallet-refer-desc">Invite a friend, earn coins</p>
        </div>
      </div>
      <span className="wallet-refer-cta">Refer →</span>
    </Link>
  );
};

// The referral page's reward band, so the wallet quotes the same figure.
// Nothing while no programme is running, like the refer tile above it.
const ReferralReward = () => {
  const programme = useReferralProgramme();
  if (!programme) return null;
  return (
    <div className="wallet-referral-reward">
      <ReferralRewardCard programme={programme} />
    </div>
  );
};

const WalletPage = createWalletPage({
  getAPIUrl,
  Navbar,
  renderBetween: () => <ReferBlock />,
  renderBeforeReferrals: () => <ReferralReward />,
});

// Logout sets next_url to the current path, so the post-login redirect lands
// back on /wallet?token=. Without storeToLocal the token is never persisted and
// every authenticated call on the page sends "Token null".
const Wallet = () => {
  const { isLoggedin } = useStateFields(['isLoggedin']);
  const { storeToLocal } = StoreToken();

  useLayoutEffect(() => {
    storeToLocal();
  }, []);

  return isLoggedin ? <WalletPage /> : null;
};

export default Wallet;
